import { useGetPermissionToFeatureMappingListQuery } from "api";

export const usePermissionFeatureMapping = () => {
    const { data } = useGetPermissionToFeatureMappingListQuery();
    const clubFeatureMap = data?.getPermissionToFeatureMappingList?.clubFeatures?.reduce((a, c) => ({ ...a, [c?.clubId as string]: c?.features?.join(",") }), {}) || {};
    const platformFeatureMap = data?.getPermissionToFeatureMappingList?.platformFeatures?.reduce((a, c) => ({ ...a, [c?.permission as string]: c?.features?.join(",") }), {}) || {};
    return { clubFeatureMap, platformFeatureMap }
}

